<img class="modal-avatar" [src]="imageSrc" />